<!-- Content Header (Page header) -->
<section class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1>Configuration Fixer</h1>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item active">Configuration Fixer</li>
        </ol>
      </div>
    </div>
  </div>
  <!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
  <!-- Default box -->
  <div class="container-fluid">
    <div class="col-lg-6">
      <mat-form-field appearance="fill">
        <mat-label>Organisations</mat-label>
        <mat-select [formControl]="cities" (valueChange)="onOrgSelect($event)">
          <mat-select-trigger>
            {{ cities.value ? cities.value.name : '' }}
            <span
              *ngIf="cities.value?.length > 1"
              class="example-additional-selection"
            >
              (+{{ cities.value.length - 1 }}
              {{ cities.value?.length === 2 ? 'other' : 'others' }})
            </span>
          </mat-select-trigger>
          <mat-option *ngFor="let org of organisations" [value]="org">{{
            org.name
          }}</mat-option>
          <mat-hint>{{ cities.value?.tag }}</mat-hint>
          <mat-error *ngIf="cities.hasError('required')"
            >Please choose an organisation</mat-error
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Configurations Type</mat-label>
        <mat-select
          [formControl]="configurationForm"
          (valueChange)="onConfigSelect($event)"
        >
          <!-- <mat-select-trigger>
            {{ cities.value ? cities.value.name : '' }}
            <span
              *ngIf="cities.value?.length > 1"
              class="example-additional-selection"
            >
              (+{{ cities.value.length - 1 }}
              {{ cities.value?.length === 2 ? 'other' : 'others' }})
            </span>
          </mat-select-trigger> -->
          <mat-option *ngFor="let org of configurationTypes" [value]="org">
            {{ org }}
          </mat-option>

          <mat-error *ngIf="cities.hasError('required')"
            >Please choose an organisation</mat-error
          >
        </mat-select>
      </mat-form-field>

      <button mat-raised-button color="primary" (click)="validate()">
        Validate
      </button>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Data now</h3>
            <div class="card-tools">
              <!-- Buttons, labels, and many other things can be placed here! -->
              <!-- Here is a label for example -->
              <span class="badge badge-primary"></span>
            </div>
            <!-- /.card-tools -->
          </div>
          <!-- /.card-header -->

          <div
            class="card-body configurationNotFoundError"
            *ngIf="configNotFound"
          >
            <i class="fas fa-exclamation-circle"></i> Configuration
            <span class="highlight">{{ orgAndConfigToValidate.key }}</span> was
            not found for
            <span class="highlight">{{ orgAndConfigToValidate.org }}</span>
          </div>
          <div class="card-body configurationApiErrors" *ngIf="showErrors">
            <ngx-json-viewer
              [json]="configurationApiErrors"
              [expanded]="true"
            ></ngx-json-viewer>
          </div>
          <div class="card-body">
            <ngx-json-viewer
              [json]="configurationApi"
              [expanded]="true"
            ></ngx-json-viewer>
          </div>
          <!-- /.card-body -->
          <div class="card-footer"></div>
          <!-- /.card-footer -->
        </div>
      </div>

      <div class="col-lg-6">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">Résultat Attendu</h3>
            <div class="card-tools">
              <!-- Buttons, labels, and many other things can be placed here! -->
              <!-- Here is a label for example -->
              <span class="badge badge-primary"></span>
            </div>
            <!-- /.card-tools -->
          </div>
          <!-- /.card-header -->
          <div class="card-body">
            <ngx-json-viewer
              [json]="exampleConfig"
              [expanded]="true"
            ></ngx-json-viewer>
          </div>
          <!-- /.card-body -->
          <div class="card-footer"></div>
          <!-- /.card-footer -->
        </div>
      </div>
    </div>
  </div>
</section>
<!-- /.content -->
